export default __webpack_public_path__ + "static/media/Shadow's Boots of the Fifth Stage.e639bb8d.jpg";